import { ReadStorageCost } from "Features/Survey";
import { Container } from "semantic-ui-react";

function ViewStorageCost () {

    return (
        <Container className="page">

            <ReadStorageCost />

        </Container>
    );
}

export default ViewStorageCost;